import { createFeatureSelector, createSelector } from '@ngrx/store';
import { CartState } from 'src/app/feature/cart/redux/cart.state';

export const selectCartState = createFeatureSelector<CartState>('cart');

export const selectCartId = createSelector(selectCartState, (state: CartState) => {
	return state?.cart?.cartId;
});

export const selectCartKey = createSelector(selectCartState, (state: CartState) => {
	return state?.cart?.cartKey;
});

export const selectCartSummary = createSelector(selectCartState, (state: CartState) => {
	return state?.summary;
});
